<template>
  <v-sheet
    v-if="currentPageName === 'organization'"
    :color="backgroundColor"
  >
    <report-container
      v-if="reportPath !== 'profile'"
      :actions="actions"
    >
      <template v-slot:report-modals>
        <org-modal />
      </template>
    </report-container>

    <v-expand-transition v-else>
      <org-profile />
    </v-expand-transition>
  </v-sheet>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import mixin from 'src/utils/mixin'

const { mapGetters: mapAuthGetters } = createNamespacedHelpers('auth')
const { mapGetters: mapLayoutGetters } = createNamespacedHelpers('layout')

export default {
  name: 'Organization',
  components: {
    OrgModal: () => import('src/internal/components/OrgModal'),
    OrgProfile: () => import('src/internal/components/OrgProfile'),
    ReportContainer: () => import('src/report/components/ReportContainer'),
  },
  mixins: [mixin],
  computed: {
    ...mapAuthGetters([
      'isInternalAdminUser',
    ]),
    ...mapLayoutGetters([
      'backgroundColor',
    ]),
    actions() {
      const adminActions = [
        {
          event: 'tools/updateRoute',
          name: 'View Details',
        },
        {
          event: 'internal/showFormOrganizationUpdate',
          name: 'Edit',
        },
        {
          event: 'internal/showFormOrganizationDelete',
          name: 'Delete',
        },
      ]

      return this.isInternalAdminUser ? adminActions : []
    },
  },
}
</script>
